import React from 'react'

import SearchHeaderPlaceholder from './subcomponents/SearchHeader/SearchHeaderPlaceholder'
import SearchPageSkeleton from './SearchPageSkeleton'

const SearchPagePlaceholder = () => {
  return <SearchPageSkeleton headerSection={<SearchHeaderPlaceholder />} />
}

export default SearchPagePlaceholder
